import { type SearchClubItemDto } from '@customTypes/types';
import { ArrowRightIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { Avatar, Badge, Card, Flex, Image, Text, Title } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { resolveImagePath } from '@/shared/helper';
import { translate } from '@/shared/i18n/translate';
import { LBActionButton } from '@/shared/ui-kit/components';

import styles from './ClubCard.module.css';

type LBClubCardProps = { data: SearchClubItemDto; navigate?: () => void };

export const LBClubCard = ({ data, navigate }: LBClubCardProps) => (
  <Card className={styles.container} onClick={navigate}>
    <Flex align='start' justify='space-between' pb={16}>
      <Flex align='start' gap={8}>
        {data.avatarPhoto ? (
          <Avatar
            src={
              data.avatarPhoto.filePath &&
              resolveImagePath(data.avatarPhoto.filePath)
            }
          />
        ) : (
          <Avatar size={38}>{data.name.slice(0, 2)}</Avatar>
        )}

        <Flex direction='column'>
          <Title order={6}>{data.name}</Title>
          <Flex direction='row' gap={8} wrap='nowrap'>
            {data.isHostessVacancyOpen && (
              <Text c='blue' fz={12}>
                <FormattedMessage id='commons.artistJobs.Hostess' />
              </Text>
            )}
            {data.isGoGoVacancyOpen && (
              <Text c='blue' fz={12}>
                <FormattedMessage id='commons.artistJobs.GoGo' />
              </Text>
            )}
            {data.isStripVacancyOpen && (
              <Text c='blue' fz={12}>
                <FormattedMessage id='commons.artistJobs.Strip' />
              </Text>
            )}
          </Flex>
        </Flex>
      </Flex>
      {/* <CreateConversationButton
        recipientProfileId={data.clubProfileId.toString()}
        recipientProfileRole={Role.cl}
      >
        <ActionIcon variant='transparent'>
          <EnvelopeIcon height={24} width={24} />
        </ActionIcon>
      </CreateConversationButton> */}
    </Flex>

    <Card.Section className={styles.imageContainer}>
      {data.searchPhoto?.filePath !== undefined && (
        <Image
          alt='artis image'
          className={styles.image}
          height={300}
          src={resolveImagePath(data.searchPhoto.filePath)}
        />
      )}
      {data.isHiring && (
        <Badge bg='green' c='white' className={styles.badge}>
          {translate('commons.artistHiringIsOpen')}
        </Badge>
      )}

      <LBActionButton className={styles.actionIcon} onClick={navigate}>
        <ArrowRightIcon height={18} width={18} />
      </LBActionButton>
    </Card.Section>

    <Flex align='end' justify='space-between' pt={16}>
      <Flex align='center' gap={4} justify='end'>
        <MapPinIcon height={18} width={18} />
        <Text c='gray' fz={14}>{data.country}</Text>
      </Flex>
    </Flex>
  </Card>
);
